import styled from "styled-components";
//components
import { Row } from 'components/Layout/Grid';
//interfaces
import { ITableDropdown } from "./interface";

export const Space = styled(Row)<ITableDropdown>`
  flex: 1;
  padding: 0.8em;
  min-width: 60px;
  height: 50px;
  align-items: center;
`